import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Home as HomeIcon, Building2, Sparkles, TruckIcon, Hotel, HardHat, ShoppingBag, Dumbbell, Warehouse, UtensilsCrossed, CheckCircle } from 'lucide-react';
import { services } from '../mock/data';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';

const iconMap = {
  Home: HomeIcon,
  Building2: Building2,
  Sparkles: Sparkles,
  TruckIcon: TruckIcon,
  Hotel: Hotel,
  HardHat: HardHat,
  ShoppingBag: ShoppingBag,
  Dumbbell: Dumbbell,
  Warehouse: Warehouse,
  UtensilsCrossed: UtensilsCrossed
};

const ServicesPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <section className="bg-black text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              Our <span className="text-red-600">Cleaning Services</span>
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Professional cleaning solutions for every need. From homes to businesses, we deliver excellence every time.
            </p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {services.map((service) => {
              const Icon = iconMap[service.icon];
              return (
                <Card key={service.id} className="overflow-hidden hover:shadow-xl transition-shadow border-gray-200">
                  <div className="h-48 overflow-hidden">
                    <img 
                      src={service.image} 
                      alt={service.title}
                      className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                  <CardHeader>
                    <div className="flex items-center mb-2">
                      <div className="w-12 h-12 bg-red-100 text-red-600 rounded-lg flex items-center justify-center mr-4">
                        <Icon className="w-6 h-6" />
                      </div>
                      <CardTitle className="text-2xl">{service.title}</CardTitle>
                    </div>
                    <CardDescription className="text-base">{service.description}</CardDescription>
                  </CardHeader>
                  <CardContent>
                    <h4 className="font-semibold mb-3 text-gray-900">What's Included:</h4>
                    <ul className="space-y-2 mb-6">
                      {service.features.map((feature, idx) => (
                        <li key={idx} className="flex items-start">
                          <CheckCircle className="w-5 h-5 text-red-600 mr-3 mt-0.5 flex-shrink-0" />
                          <span className="text-gray-700">{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Need a Custom Cleaning Plan?
          </h2>
          <p className="text-xl text-gray-600 mb-8">
            We'll create a tailored solution that fits your specific needs and budget
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact">
              <Button size="lg" className="bg-red-600 hover:bg-red-700 text-white w-full sm:w-auto">
                Get a Free Quote
              </Button>
            </Link>
            <Link to="/booking">
              <Button size="lg" variant="outline" className="border-gray-300 hover:bg-gray-100 w-full sm:w-auto">
                Book a Consultation
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;
